/* eslint-disable css-modules/no-unused-class */
import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './NewsArchive.css';
import { COMPANY_FILTERS } from '../../webconfig';
import Link from '../../components/Link';

class NewsArchive extends React.Component {
  static propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    news: PropTypes.array.isRequired,
    period: PropTypes.string.isRequired,
    publication: PropTypes.string.isRequired,
  };

  renderOldNewsSection(news) {
    return (
      <div className={s.oldNewsSection}>
        {news.map(item => {
          const { id, title, date } = item;
          const toPath = `/publications/${this.props.publication}/news/${id}`;
          return (
            <Link
              to={toPath}
              className={s.oldNewsLink}
              key={`news-list-item-${id}`}
            >
              {`${moment(date).format('MMM DD, YYYY')} - ${title}`}
            </Link>
          );
        })}
      </div>
    );
  }

  render() {
    return this.props.news.length !== 0 ? (
      <div id={`page-transitions ${s.root}`}>
        <div
          id="page-content"
          className={`page-content ${s.contentPageCustom}`}
        >
          <div className="content-strip half-bottom">
            <div className="above-overlay">
              <h1
                className={`${s.sectionTitle} center-text uppercase ultrabold small-top fa-2x small-bottom`}
              >
                {COMPANY_FILTERS[this.props.publication]} Archive{' '}
                {moment(this.props.period, 'YYYY-MM').format('MMM YYYY')}
              </h1>
            </div>
            <div className="overlay opacity-100" />
          </div>
          <div className={s.allNewsSection}>
            {this.renderOldNewsSection(this.props.news)}
          </div>
        </div>
      </div>
    ) : (
      <div id={`page-transitions ${s.root}`}>
        <div className="content-strip half-bottom">
          <div className="above-overlay">
            <h1
              className={`${s.sectionTitle} center-text uppercase ultrabold small-top fa-2x small-bottom`}
            >
              {COMPANY_FILTERS[this.props.publication]} Archive{' '}
              {moment(this.props.period, 'YYYY-MM').format('MMM YYYY')}
            </h1>
          </div>
          <div className="overlay opacity-100" />
        </div>
        <div className={s.noNewsTitle}>
          <span>No articles</span>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(NewsArchive);
